import { ServiceClient, type InterceptFn, type TokenSource } from '@compassdigital/sdk.typescript';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { useLoadingStore } from '@centric-os/stores/loading/use-loading-store';

/**
 * Creates a token source that resolves the current auth token on each request.
 */
function createTokenSource(): TokenSource {
  return () => useAuthStore().getValidAccessToken();
}

/**
 * Creates an intercept function that toggles the global loading state.
 */
function createIntercept(): InterceptFn {
  return async (req, fetch) => {
    const loadingStore = useLoadingStore();
    loadingStore.loading = true;
    try {
      return await fetch(req);
    } finally {
      loadingStore.loading = false;
    }
  };
}

/**
 * Creates a ServiceClient configured with auth-token injection and loading-state toggling.
 */
export function createServiceClient(): ServiceClient {
  return new ServiceClient({
    base_url: import.meta.env.VITE_CDL_ENDPOINT_BASE_URL,
    token: createTokenSource(),
    intercept: createIntercept(),
  });
}
